/** Max capacity for a class: max_boys + max_girls, or legacy max_students only. */
export function getClassCapacityTotal(cls) {
  if (!cls) return 0;
  const maxBoys = parseInt(cls.max_boys, 10) || 0;
  const maxGirls = parseInt(cls.max_girls, 10) || 0;
  if (maxBoys > 0 || maxGirls > 0) return maxBoys + maxGirls;
  return parseInt(cls.max_students, 10) || 0;
}

/** Recorded strength total (latest boys + girls on file for this class). */
export function getClassEnrolledTotal(cls) {
  if (!cls) return 0;
  if (cls.enrolled_total != null && cls.enrolled_total !== '') {
    return parseInt(cls.enrolled_total, 10) || 0;
  }
  return (parseInt(cls.boys, 10) || 0) + (parseInt(cls.girls, 10) || 0);
}
